import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';

export function fmtDate(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  const date = parseISO(value);
  return isValid(date) ? format(date, 'd MMM yyyy') : fallback;
}

export function fmtDateTime(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  const date = parseISO(value);
  return isValid(date) ? format(date, 'd MMM yyyy, HH:mm') : fallback;
}

export function fmtRelative(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  const date = parseISO(value);
  if (!isValid(date)) return fallback;
  return `${formatDistanceToNowStrict(date)} ago`;
}

export function fmtNumber(value: number): string {
  return new Intl.NumberFormat('en-GB').format(value);
}

/** Days until a date; negative when overdue. */
export function daysUntil(value: string | null | undefined): number | null {
  if (!value) return null;
  const date = parseISO(value);
  if (!isValid(date)) return null;
  return Math.ceil((date.getTime() - Date.now()) / 86_400_000);
}

export function titleCase(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0]}${parts[parts.length - 1]![0]}`.toUpperCase();
}

/** Stable colour per person, so avatars stay recognisable. */
export function avatarColor(seed: string): string {
  const palette = ['#2f34c9', '#0f766e', '#b45309', '#9333ea', '#be123c', '#0369a1', '#4d7c0f', '#c2410c'];
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return palette[hash % palette.length]!;
}
